import React, { useMemo } from "react";

import { IOmiCustomerFragment, IOmiCustomerTierSettingsFragment, IOmiUserFragment } from "./OmiUserContext.generated";

export interface IOmiUserContext {
    omiUser: IOmiUserFragment | undefined;
    omiCustomer: IOmiCustomerFragment | undefined;
    omiTierSettings: IOmiCustomerTierSettingsFragment | undefined;
    omiContractsEmailAddress: string | undefined;
}

export const OmiUserContext = React.createContext<IOmiUserContext>({
    omiUser: undefined,
    omiCustomer: undefined,
    omiTierSettings: undefined,
    omiContractsEmailAddress: undefined,
});

export const OmiUserContextProvider: React.FC<React.PropsWithChildren<IOmiUserContext>> = ({
    omiCustomer,
    omiUser,
    omiTierSettings,
    omiContractsEmailAddress,
    children,
}) => {
    const contextValue = useMemo(
        (): IOmiUserContext => ({
            omiCustomer,
            omiUser,
            omiTierSettings,
            omiContractsEmailAddress,
        }),
        [omiContractsEmailAddress, omiCustomer, omiTierSettings, omiUser],
    );

    return <OmiUserContext.Provider value={contextValue}>{children}</OmiUserContext.Provider>;
};
